const CPF_LENGTH = 11;

const normalizeCpf = (value: string): string => (value || '').replace(/\D/g, '');

const calculateCheckDigit = (base: string, factor: number): number => {
  let total = 0;

  for (const digit of base) {
    total += Number(digit) * factor;
    factor -= 1;
  }

  const remainder = total % 11;

  return remainder < 2 ? 0 : 11 - remainder;
};

export const getCpfValidationError = (value: string): string | null => {
  const cpf = normalizeCpf(value);

  if (!cpf) {
    return 'Informe seu CPF para continuar.';
  }

  if (cpf.length !== CPF_LENGTH) {
    return 'O CPF deve ter 11 numeros.';
  }

  if (!/^\d{11}$/.test(cpf)) {
    return 'O CPF deve conter apenas numeros.';
  }

  if (/^(\d)\1+$/.test(cpf)) {
    return 'O CPF informado e invalido.';
  }

  const firstDigit = calculateCheckDigit(cpf.slice(0, 9), 10);
  const secondDigit = calculateCheckDigit(cpf.slice(0, 9) + String(firstDigit), 11);

  if (cpf !== cpf.slice(0, 9) + String(firstDigit) + String(secondDigit)) {
    return 'CPF invalido. Verifique os digitos finais informados.';
  }

  return null;
};

export const isValidCpf = (value: string): boolean => !getCpfValidationError(value);

export const getNormalizedCpf = (value: string): string => normalizeCpf(value);